"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.apiDelete = exports.apiPut = exports.apiPost = exports.apiGet = exports.getHeaders = exports.getUrlWithQueryParams = exports.getQueryString = exports.handlePromiseErrors = void 0;
var helpers_1 = require("./helpers");
/**
 * Check HTTP promise response for server error response (non 2XX status) and reject promise is error
 *
 * @param promise the HTTP promise to check for HTTP status code of 2XX for success
 *
 * @returns promise for the HTTP connection with catch supporting error
 */
var handlePromiseErrors = function (promise) {
    var promiseInfo = (0, helpers_1.generatePromiseObjects)();
    promise.then(function (response) {
        if (response.ok) {
            promiseInfo.resolver(response);
        }
        else {
            promiseInfo.rejecter(response);
        }
        return response;
    }).catch(function (error) {
        promiseInfo.rejecter(error);
    });
    return promiseInfo.promise;
};
exports.handlePromiseErrors = handlePromiseErrors;
/**
 * Make params into string for query params
 *
 * @param params object of key:value pairs
 *
 * @returns a string of query params that is URL safe
 */
var getQueryString = function (params) {
    var queryString = '';
    Object.keys(params || {}).forEach(function (key) {
        var value = params[key];
        queryString += "".concat(key, "=").concat(encodeURIComponent(value), "&");
    });
    return queryString.slice(0, -1);
};
exports.getQueryString = getQueryString;
/**
 * Create URL with query params if params are set
 *
 * @param url the url string
 * @param params object of key:value pairs
 *
 * @returns a string of url and query params together
 */
var getUrlWithQueryParams = function (url, params) {
    if (params) {
        var queryString = (0, exports.getQueryString)(params);
        url = url + (queryString ? "?".concat(queryString) : '');
    }
    return url;
};
exports.getUrlWithQueryParams = getUrlWithQueryParams;
/**
 * Add required headers and additional headers together for network requests
 *
 * @param additionalHeaders object of key:value of extra header items
 *
 * @returns an object of key:value of all headers (additional and required)
 */
var getHeaders = function (additionalHeaders) {
    var requiredHeaders = {
        'Content-Type': 'application/json'
    };
    Object.keys(additionalHeaders || {}).forEach(function (key) {
        requiredHeaders[key] = additionalHeaders[key];
    });
    return requiredHeaders;
};
exports.getHeaders = getHeaders;
/**
 * Make a GET for retrieving data from a server
 *
 * @param url the url string of the resource on the server
 * @param queryParams an object of key:value to be used for the query params
 * @param additionalHeaders an object of key:value to be used for additional headers
 *
 * @returns a promise that will resolve with the response from the server or reject if network/server error
 */
var apiGet = function (url, queryParams, additionalHeaders) {
    return (0, exports.handlePromiseErrors)(fetch((0, exports.getUrlWithQueryParams)(url, queryParams), {
        headers: (0, exports.getHeaders)(additionalHeaders)
    }));
};
exports.apiGet = apiGet;
/**
 * Make a POST for creating data on the server
 *
 * @param url the url string of the resource on the server
 * @param data the data (JSON) to send to the server
 * @param queryParams an object of key:value to be used for the query params
 * @param additionalHeaders an object of key:value to be used for additional headers
 *
 * @returns a promise that will resolve with the response from the server or reject if network/server error
 */
var apiPost = function (url, data, queryParams, additionalHeaders) {
    return (0, exports.handlePromiseErrors)(fetch((0, exports.getUrlWithQueryParams)(url, queryParams), {
        method: 'POST',
        body: JSON.stringify(data),
        headers: (0, exports.getHeaders)(additionalHeaders)
    }));
};
exports.apiPost = apiPost;
/**
 * Make a PUT for creating data on the server
 *
 * @param url the url string of the resource on the server
 * @param data the data (JSON) to send to the server
 * @param queryParams an object of key:value to be used for the query params
 * @param additionalHeaders an object of key:value to be used for additional headers
 *
 * @returns a promise that will resolve with the response from the server or reject if network/server error
 */
var apiPut = function (url, data, queryParams, additionalHeaders) {
    return (0, exports.handlePromiseErrors)(fetch((0, exports.getUrlWithQueryParams)(url, queryParams), {
        method: 'PUT',
        body: JSON.stringify(data),
        headers: (0, exports.getHeaders)(additionalHeaders)
    }));
};
exports.apiPut = apiPut;
/**
 * Make a DELETE on a resource on the server
 *
 * @param url the url string of the resource on the server
 * @param queryParams an object of key:value to be used for the query params
 * @param additionalHeaders an object of key:value to be used for additional headers
 *
 * @returns a promise that will resolve with the response from the server or reject if network/server error
 */
var apiDelete = function (url, queryParams, additionalHeaders) {
    return (0, exports.handlePromiseErrors)(fetch((0, exports.getUrlWithQueryParams)(url, queryParams), {
        method: 'DELETE',
        headers: (0, exports.getHeaders)(additionalHeaders)
    }));
};
exports.apiDelete = apiDelete;
exports.default = {
    apiGet: exports.apiGet,
    apiPost: exports.apiPost,
    apiPut: exports.apiPut,
    apiDelete: exports.apiDelete,
    getHeaders: exports.getHeaders,
    getUrlWithQueryParams: exports.getUrlWithQueryParams,
    getQueryString: exports.getQueryString,
    handlePromiseErrors: exports.handlePromiseErrors
};
